import {useQuery, useQueryClient, useMutation} from 'react-query';
import {fetchReconText, saveReconText} from '../../../services/proto/Recon/reconText';

export function useRteQuery(onSuccess: (data) => void, enabled) {
    return useQuery(['rteText'], fetchReconText, {
        enabled,
        onSuccess
    });
}

export function useRteMutation() {
    const queryClient = useQueryClient();
    return useMutation((data: any) => saveReconText(data.toString('html')), {
        onSuccess: () => {
            queryClient.invalidateQueries('rteText');
        }
    });
}
